import {Fragment, useEffect, useRef} from 'react';
import {SOOP, USER} from '@/constants/help';
import BotMessage from '../BotMessage';
import UserMessage from '../UserMessage';
import MessageLoading from '../MessageLoading';
import {MessageType} from '../type';
import styles from './ChatbotMessages.module.scss';

interface ChatbotMessagesProps {
  messages: MessageType[];
  handleSend: (text: string) => void;
  isPending: boolean;
  setHasHeaderShadow: (hasHeaderShadow: boolean) => void;
}

const ChatbotMessages = ({
  messages,
  handleSend,
  isPending,
  setHasHeaderShadow,
}: ChatbotMessagesProps) => {
  // 챗봇 스크롤 이동
  const bottomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const scrollToBottom = () => {
      bottomRef.current?.scrollIntoView({behavior: 'smooth'});
    };
    scrollToBottom();
  }, [messages, isPending]);

  // 스크롤시 헤더 클래스 추가
  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const ref = contentRef.current;
    if (!ref) {
      return;
    }

    const handleScroll = () => {
      setHasHeaderShadow(ref.scrollTop > 0);
    };

    ref.addEventListener('scroll', handleScroll);
    return () => {
      ref.removeEventListener('scroll', handleScroll);
    };
  }, [setHasHeaderShadow]);

  return (
    <div ref={contentRef} className={styles.wrapper}>
      {messages.map((item, idx) => (
        <Fragment key={`chat-${idx}`}>
          {item.role === SOOP && (
            <BotMessage {...item} handleSend={handleSend} />
          )}
          {item.role === USER && <UserMessage {...item} />}
        </Fragment>
      ))}
      {isPending && <MessageLoading />}
      <div ref={bottomRef} />
    </div>
  );
};

export default ChatbotMessages;
